import React from "react";

export default function LeadRemark({ remarkData = [], isOpen, onClose }) {
  if (!isOpen) return null; // 👈 important

  return (
    <>
      {/* backdrop */}
    

      <div
        className={`modal fade ${isOpen ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ display: "block", paddingRight: "15px" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            
            <div className="modal-header">
              <h5 className="modal-title">Remarks</h5>
              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                <span>&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <table className="table table-striped table-bordered bulk_action mytable">
                <thead>
                  <tr>
                    <th width="50">S.No</th>
                    <th width="180">Next Follow Up Date</th>
                    <th width="120">Status</th>
                    <th>Remark</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {remarkData.length > 0 ? (
                    remarkData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                            
                            {item?.nextFollowUpDate
                            ? new Date(item.nextFollowUpDate).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            })
                            : "-"}
                        </td>
                        <td>
                          <span className="badge badge-success">
                            {item.status}
                          </span>
                        </td>
                        <td>{item.remarks}</td>
                        <td>{item?.createdAt
                                ? new Date(item.createdAt).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                })
                                : "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No remarks found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
